// Module
var code = "<template> <div class=\"days-container\"> <button class=\"day-btn btn btn-secondary\" repeat.for=\"[key, value] of Days | enumToMap\" click.delegate=\"handleDaySelect(value.value, $event)\"> ${value.name} </button> </div> </template> ";
// Exports
export default code;